import React, { useState } from 'react';
import axios from 'axios';
import './Admin.css';

// Configure axios for local development
if (window.location.hostname === 'localhost') {
  axios.defaults.baseURL = 'http://localhost:9894';
}

const Admin = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.post('/api/v1/admin/auth', { password });
      const token = response.data.token;
      localStorage.setItem('adminToken', token);
      setIsAuthenticated(true);
      fetchData(token);
    } catch (err) {
      setError('Invalid password');
    }
    setLoading(false);
  };

  const fetchData = async (token) => {
    try {
      const response = await axios.get('/api/v1/admin/data', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(response.data?.data || []);
    } catch (err) {
      setError('Failed to fetch data');
      setIsAuthenticated(false);
      setData([]);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
    setData([]);
    setPassword('');
  };

  if (isAuthenticated) {
    return (
      <div className="admin-container">
        <h1>Admin Portal</h1>
        <button onClick={handleLogout}>Logout</button>
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User ID</th>
              <th>Pages</th>
              <th>Cursor Trail Count</th>
              <th>User Agent</th>
              <th>Screen</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>IP</th>
              <th>Referrer</th>
              <th>Language</th>
              <th>Timezone</th>
              <th>Viewport</th>
              <th>DPR</th>
              <th>Touch</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.user_id}</td>
                <td>{item.pages}</td>
                <td>{item.cursor_trail_count}</td>
                <td>{item.user_agent}</td>
                <td>{item.screen_width}x{item.screen_height}</td>
                <td>{item.start_time}</td>
                <td>{item.end_time}</td>
                <td>{item.ip_address}</td>
                <td>{item.referrer}</td>
                <td>{item.language}</td>
                <td>{item.timezone}</td>
                <td>{item.viewport_width}x{item.viewport_height}</td>
                <td>{item.device_pixel_ratio}</td>
                <td>{item.touch_support ? 'Yes' : 'No'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="admin-login">
      <h1>Admin Login</h1>
      <form onSubmit={handleLogin}>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default Admin;